<template>
  <div>
    <v-row no-gutters class="form-group" v-if="!noLabel">
      <span v-if="label !== ''" class="item-label">{{ label }}</span>
      <span v-else class="item-label" style="color:white" />
      <label class="form-group-label">
        <span v-if="required" class="mandatory">必須</span>
      </label>
    </v-row>
    <quill-editor
      ref="quillEditor"
      v-bind="computedProps"
      v-model="content"
      :options="readonly ? readOnlyOption : ([undefined, null].includes(options) ? editorOption : options)"
      @change="onEditorChange($event)"
      :disabled="readonly"
    />
  </div>
</template>

<script>
export default {
  name: 'DdQuillEditer',
  components: {
  },
  props: {
    /**
     * オプション
     */
    options: Object,
    /**
     * ラベル
     */
    label: {
      Type: String,
      default: ''
    },
    /**
     * コンテンツ
     */
    content: {
      Type: String,
      default: ''
    },
    /**
     * 必須指定
     */
    required: {
      Type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    },
    /**
     * 文字列長
     */
    length: Number,
    /**
     * 読み取り専用
     */
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    editorOption: {
      theme: 'snow',
      scrollingContainer: '.scroll-container',
      placeholder: '',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          [{ script: 'sub' }, { script: 'super' }],
          [{ indent: '-1' }, { indent: '+1' }],
          [{ direction: 'rtl' }],
          [{ size: ['small', false, 'large', 'huge'] }],
          [{ font: [] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ['clean'],
          // ['link', 'image', 'video']
          ['link']
        ]
      }
    },
    // 表示用Wysiwyg
    readOnlyOption: {
      theme: 'bubble',
      placeholder: '',
      modules: {
        toolbar: []
      }
    }
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.$props.class + (this.required ? ' required-item' : ''),
        readonly: this.readonly,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    }
  },
  mounted: function () {
    console.log('mounted', this.content)
  },
  methods: {
    onBlur: function (e) {
      this.$emit('update:content', this.content)
    },
    onEditorChange: function ({ quill, html, text }) {
      this.$emit('update:content', html)
    }
  }
}
</script>
<style scoped>
::v-deep .ql-container {
  box-sizing: border-box !important;
  font-size: 1em !important;
  margin: 0px !important;
  position: relative !important;
  white-space: pre !important;
}
::v-deep .ql-editor {
  /* white-space: pre !important; */
  color: #1F2B38;
}
</style>
